/* global $ */

const $mediaGrid = $('.js-media-grid');

const mediaGrid = {
  initialize() {
    if ($mediaGrid.length) {
      // eslint-disable-next-line global-require
      const lightbox = require('lightbox2');

      lightbox.option({
        albumLabel: '%1/%2',
        disableScrolling: true,
      });
    }
  },
};

export default mediaGrid;
